exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2koJ1LN-0bSGT_9Kd05Baw{height:50px;line-height:50px;background-color:#fff;z-index:2}.lKiCx7lwBl0FKptdW-EeQ{display:inline-block}.lKiCx7lwBl0FKptdW-EeQ>label{font-size:1em;padding:0 1em;font-weight:700}.lKiCx7lwBl0FKptdW-EeQ>input{font-size:1em;width:5em}", ""]);

// exports
exports.locals = {
	"config": "_2koJ1LN-0bSGT_9Kd05Baw",
	"formGroup": "lKiCx7lwBl0FKptdW-EeQ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules!./~/less-loader!./src/components/Config/styles.less
// module id = 113
// module chunks = 0